import _ from "lodash";
import React, { useState, useId } from "react";
import { connect } from "react-redux";

import { useI18n } from "Hooks";
import { compose } from "lib/apolloClient";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import { Button, TextInput, Modal, FormInputError } from "@toddle-edu/ds-web";

import classes from "./AddChildModal.scss";
import { getChildrenQuery } from "modules/CommonQuery";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import { addChild } from "Courses/modules/CoursesModule";

const AddChildModal = props => {
  const {
    setSuccessModal,
    setAddChildModal,
    setChildDetails,
    userId,
    addChild,
    includePlatformUserQuery,
    refetchQueries = [],
  } = props;

  const { t } = useI18n();

  const addChildErrorId = useId();

  const [studentCode, setStudentCode] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showFullScreenLoader, setShowFullScreenLoader] = useState(false);

  const handleInputCode = value => {
    setStudentCode(value);
    setErrorMessage("");
  };

  const onCloseClick = () => {
    setAddChildModal(false);
    setStudentCode("");
  };

  const finalRefetchQueries = [
    ...refetchQueries,
    {
      query: getChildrenQuery,
      variables: {
        id: userId,
        type: "FAMILY_MEMBER",
      },
    },
  ];

  const onSubmitClick = async () => {
    if (!studentCode) {
      return;
    }

    setShowFullScreenLoader(true);

    const childData = await addChild({
      studentCode,
      userId,
      signInFlow: false,
      setErrorMessage,
      refetchQueries: finalRefetchQueries,
      includePlatformUserQuery,
    });

    setShowFullScreenLoader(false);

    if (!_.isEmpty(childData)) {
      setChildDetails(childData);
      setStudentCode("");
      setSuccessModal(true);
      setAddChildModal(false);
    }
  };

  const handleKeyPress = e => {
    if (e.key === "Enter") {
      onSubmitClick();
    }
  };

  const componentTestId = "homepage-addChildModal";

  return (
    <>
      <Modal
        dsVersion="2.0"
        width="365px"
        height="fit-content"
        isOpen={true}
        onClose={onCloseClick}
      >
        <Modal.Header
          title={t("common:add_with_label", { label: t("common:child") })}
          subtitle={t("common:add_another_child")}
        ></Modal.Header>
        <Modal.Body>
          <div
            className={classes.inputContainer}
            data-test-id={`${componentTestId}-familyInviteCode`}
          >
            <TextInput
              dsVersion="2.0"
              size="medium"
              label={t("common:family_invite_code")}
              placeholder={t("common:enter_with_label", {
                label: t("common:family_invite_code"),
              })}
              autoFocus={true}
              onKeyPress={handleKeyPress}
              onChange={e => {
                handleInputCode(e.target.value);
              }}
              aria-describedby={addChildErrorId}
              testId={`${componentTestId}-familyInviteCode-input`}
            />
            <FormInputError id={addChildErrorId} error={errorMessage} />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className={classes.buttonsContainer}>
            <Button
              dsVersion="2.0"
              size="medium"
              variant="neutral"
              type="outlined"
              onClick={onCloseClick}
            >
              {t("common:cancel")}
            </Button>
            <Button
              dsVersion="2.0"
              size="medium"
              variant="primary"
              disabled={!studentCode}
              onClick={onSubmitClick}
            >
              {t("common:add_with_label", { label: t("common:child") })}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      {showFullScreenLoader && <FullScreenLoader />}
    </>
  );
};

const mapActionCreators = {
  addChild,
};

const mapStateToProps = () => {
  const userInfo = getUserInfo();
  return {
    userId: userInfo.id,
  };
};

export default compose(connect(mapStateToProps, mapActionCreators))(
  AddChildModal
);
